import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Container, VLine } from "../styles";
import { Container as CardContainer } from "../CardHistorico/styles";
import { SkeletonItemsWrap } from "./styles";

interface SkeletonItemHistoricoProps {
  lastItem?: boolean;
}

export default function SkeletonItemHistorico({ lastItem = false }: SkeletonItemHistoricoProps) {
  return (
    <Container>
      <VLine lastItem={lastItem} />
      <SkeletonItemsWrap className="items">
        <div className="data">
          <Skeleton height={12} width={70} className="data-texto skeleton-data-texto" />
          <Skeleton height={14} width={65} className="hora-texto skeleton-hora-texto" />
        </div>
        <div className="icone">
          <Skeleton circle height={30} width={30} />
        </div>
        <CardContainer>
          <div className="top">
            <div className="acao">
              <Skeleton height={16} width={200} className="skeleton-acao" />
            </div>
            <div className="infos">
              <Skeleton circle height={16} width={16} />
              <Skeleton height={10} width={10} circle />
              <Skeleton height={12} width={50} className="codigo skeleton-codigo" />
              <Skeleton height={16} width={16} />
            </div>
          </div>
          <div className="bottom">
            <Skeleton circle height={14} width={14} />
            <Skeleton height={12} width={120} className="skeleton-bottom" />
            <Skeleton height={20} width={80} borderRadius={11} className="skeleton-badge" />
          </div>
        </CardContainer>
      </SkeletonItemsWrap>
    </Container>
  );
}
